import {
  CreateDependentPayload,
  DependentModel,
  UpdateDependentPayload,
} from "types/dependent.types";
import { baseApi } from "./baseApi";
import { FormatResponse, TAG_TYPES } from "types";

const URL_DEPENDENTS = "dependents";

const dependentApiService = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    // Get list
    getAllDependents: builder.query<
      FormatResponse<{ count: number; rows: DependentModel[] }>,
      { query: { staffId?: string; driverId?: string } }
    >({
      query: ({ query }) => {
        const params = new URLSearchParams();
        if (query.staffId) params.append("staffId", query.staffId);
        if (query.driverId) params.append("driverId", query.driverId);
        const queryString = params.toString();
        return {
          url: queryString
            ? `${URL_DEPENDENTS}?${queryString}`
            : URL_DEPENDENTS,
          method: "GET",
        };
      },
      providesTags: [{ type: TAG_TYPES.DEPENDENT, id: "LIST" }],
    }),
    // Get by ID
    getDependentById: builder.query<
      FormatResponse<DependentModel>,
      { id: string }
    >({
      query: ({ id }) => ({
        url: `${URL_DEPENDENTS}/${id}`,
        method: "GET",
      }),
      providesTags: (_result, _error, { id }) => [
        { type: TAG_TYPES.DEPENDENT, id },
      ],
    }),

    // Create
    createDependent: builder.mutation<
      FormatResponse<DependentModel>,
      CreateDependentPayload
    >({
      query: (data) => ({
        url: URL_DEPENDENTS,
        method: "POST",
        data,
      }),
      invalidatesTags: [{ type: TAG_TYPES.DEPENDENT, id: "LIST" }],
    }),

    // Update
    updateDependent: builder.mutation<
      FormatResponse<DependentModel>,
      { id: string } & UpdateDependentPayload
    >({
      query: ({ id, ...data }) => ({
        url: `${URL_DEPENDENTS}/${id}`,
        method: "PATCH",
        data,
      }),
      invalidatesTags: (_result, _error, { id }) => [
        { type: TAG_TYPES.DEPENDENT, id },
        { type: TAG_TYPES.DEPENDENT, id: "LIST" },
      ],
    }),

    // Delete
    deleteDependent: builder.mutation<
      FormatResponse<{ success: boolean }>,
      { id: string }
    >({
      query: ({ id }) => ({
        url: `${URL_DEPENDENTS}/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: (_result, _error, { id }) => [
        { type: TAG_TYPES.DEPENDENT, id },
        { type: TAG_TYPES.DEPENDENT, id: "LIST" },
      ],
    }),
  }),
});

export const {
  useGetAllDependentsQuery,
  useGetDependentByIdQuery,
  useCreateDependentMutation,
  useUpdateDependentMutation,
  useDeleteDependentMutation,
} = dependentApiService;
